import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { DeliveryMethodSelect, IDeliveryMethodSelectProps } from './DeliveryMethodSelect';
import * as _ from 'lodash';

const GetDeliveryMethodsListQuery = gql`
  query ($domain: String!) {
    deliveryMethods(where: { eshop: { domain: $domain }}) {
      id
      title
      name
      price
    }
  }
`;

export default withRouter(compose<{}, IDeliveryMethodSelectProps>(
  graphql<IDeliveryMethodSelectProps, any>(GetDeliveryMethodsListQuery, {
    name: 'methods',
    options: props => ({
      variables: {
        domain: props.match.params.eshop
      }
    })
  }),
  withProps(({ methods }: any) => {
    return {
      methods: methods.deliveryMethods,
    };
  }),
)(DeliveryMethodSelect));



// WEBPACK FOOTER //
// ./src/components/Others/DeliveryMethodSelect/index.ts